<template>
    <v-app>
        <v-main>
            <section fluid class="vh-100 mb-2">
                <v-row align="center" class="h-100">
                    <!-- Imagen en una columna -->
                    <v-col cols="12" md="7">
                        <v-img :src="require('../../assets/rcplogo.png')" class="my-3" contain height="auto" max-height="350" />
                    </v-col>
                    <!-- Formulario en la otra columna -->
                    <v-col cols="12" md="4">
                        <!--<h2>Coming Soon ...</h2>-->                        
                        <v-card>
                            <div class="col-md-12 col-xl-12">
                                <v-img :src="require('../../assets/login2.png')" class="my-3" contain height="80" />
                            </div>
                            <v-card-title>
                                <h2>Iniciar Sesión</h2>
                            </v-card-title>
                            <v-card-text>
                                <v-form v-if="acceso === 0" ref="loginForm" @submit.prevent="validarYEnviarCodigo">
                                    <v-text-field v-model="correo_corporativo" :rules="[validar2]" label="Correo" required></v-text-field>
                                    <!--<v-text-field v-model="pswd" :rules="[validar]" label="Contraseña" type="password" required></v-text-field>
                                    <v-spacer></v-spacer>
                                    <a href="#" class="text-body-2 font-weight-regular" @click="abrir_dialog_forgot">Recover passwpord</a> - 
                                    <a href="#" class="text-body-2 font-weight-regular" @click="abrir_dialog_register">Register</a>-->
                                    <v-btn style="color: black" x-large block type="submit" class="mt-2" v-if="acceso === 0" :disabled="!isValidForm">Ingresar</v-btn>                            
                                </v-form>
                                <v-form v-if="acceso === 1" ref="loginForm1" @submit.prevent="login1">
                                    <v-text-field v-model="correo_corporativo" :rules="[validar2]" label="Correo" required></v-text-field>
                                    <v-text-field v-model="code_login" label="Código de Verificación" type="password" required></v-text-field>
                                    <!--<v-text-field v-model="pswd" :rules="[validar]" label="Contraseña" type="password" required></v-text-field>
                                    <v-spacer></v-spacer>
                                    <a href="#" class="text-body-2 font-weight-regular" @click="abrir_dialog_forgot">Recuperar contraseña</a>
                                    <a href="#" class="text-body-2 font-weight-regular" @click="abrir_dialog_register">Register</a>-->
                                    <v-btn style="color: black" x-large block type="submit" class="mt-2" v-if="acceso === 1" :disabled="!isValidForm1">Ingresar</v-btn>                            
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-footer color="rgb(230, 233, 242)" dark height="auto" class="mt-0">
                    <div class="d-flex flex-column flex-md-row text-center justify-space-between py-4 px-1 px-xl-1">
                        <div class="mb-3 mb-md-0" style="color: rgb(0, 30, 67)">
                        &copy;Developed by the team of ITS - UNODC ROCOL - 2024 LabCC - Version 1.0.0.1 Privacy          
                        </div>
                        <v-img :src="require('@/assets/logo2.png')" max-height="100%" max-width="9%" contain>
                        <a href="https://www.unodc.org/unodc/es/index.html" target="_blank" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></a>
                        </v-img>
                    </div>
                </v-footer>
            </section>
        </v-main>

        <!-- Cuadro de diálogo para recuperar contraseña -->
        <v-dialog v-model="dialog_register" max-width="45%">
            <v-card>
                <v-card-title>
                    <span class="text-h5">New User</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm12 md4>
                                <v-text-field v-model="dato.name" label="Name" :rules="[validar1]" auto-grow></v-text-field>
                            </v-flex>                                            
                            <v-flex xs12 sm12 md4>
                                <v-text-field v-model="dato.surname" label="Surname" :rules="[validar1]" auto-grow></v-text-field>
                            </v-flex>   
                            <v-flex xs12 sm12 md6>
                                <v-text-field v-model="dato.correo_corporativo" label="Corporate Email" :rules="[validarCorreo]" auto-grow></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md5>
                                <v-select v-model="dato.oid_agency" :items="agencies" item-text="n_agency" item-value="oid" label="Agency">
                                    <template v-slot:label> Agency
                                        <span class="red-asterisk">*</span>
                                    </template>
                                </v-select>
                            </v-flex><!--
                            <v-flex xs12 sm12 md4>
                                <v-select v-model="dato.oid_rol" :items="rols" item-text="n_role" item-value="oid" label="Role"></v-select>
                            </v-flex>-->
                            <v-flex xs12 sm12 md6>
                                <v-text-field v-model="dato.pswd" label="Password" type="password" :rules="[validar]"></v-text-field> 
                            </v-flex>                                        
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="cerrar">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="guardar" :disabled="!isValidForm3">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <!-- Cuadro de diálogo para recuperar contraseña -->
        <v-dialog v-model="dialog_forgot" max-width="25%">
            <v-card>
                <v-card-title class="headline">Recover Password</v-card-title>
                <v-card-text>
                    <v-form v-if="recover === 0" @submit.prevent="resetPassword">
                        <v-text-field v-model="correo_corporativo" :rules="[validar2]" label="Correo" required></v-text-field>
                        <v-spacer></v-spacer>
                        <v-btn style="color: black" x-large block type="submit" class="mt-2" v-if="recover === 0" :disabled="!isValidForm2">Verificar Correo</v-btn>                            
                    </v-form>
                    <v-form v-if="recover === 1" @submit.prevent="resetPassword1">
                        <v-text-field v-model="correo_corporativo" :rules="[validar2]" label="Correo" required></v-text-field>
                        <v-text-field v-model="code_login" label="Código de Verificación" type="password" required></v-text-field>
                        <v-spacer></v-spacer>
                        <v-btn style="color: black" x-large block type="submit" class="mt-2" v-if="recover === 1" :disabled="!isValidForm2_1">Verificar Correo</v-btn>                            
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secundary" @click="cerrar_dialog_forgot">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog ingresando -->
        <v-dialog v-model="dialog_ingresar" max-width="40%">
            <v-card>
                <v-card-title class="headline">Entering .....</v-card-title>
            </v-card>
        </v-dialog>

        <!-- Mensaje de confirmación-->
        <v-snackbar v-model="user_error" color="error" top>
            Usuario y/o contraseña incorrectas. Intente nuevamente.
            <template v-slot:action="{ attrs }">
                <v-btn color="error" text v-bind="attrs" @click="user_error = false">Cerrar</v-btn>
            </template>
        </v-snackbar>

        <!-- Mensaje de confirmación-->
        <v-snackbar v-model="codigo_error" color="error" top>
            Incorrect username and/or password and/or code. Try again
            <template v-slot:action="{ attrs }">
                <v-btn color="error" text v-bind="attrs" @click="codigo_error = false">Cerrar</v-btn>
            </template>
        </v-snackbar>

        <!-- Mensaje de codigo-->
        <v-snackbar v-model="codigo_enviado" color="success" top>
            A verification code has been sent, please enter it to continue
            <template v-slot:action="{ attrs }">
                <v-btn color="success" text v-bind="attrs" @click="codigo_enviado = false">Cerrar</v-btn>
            </template>
        </v-snackbar>
        <!-- Mensaje de codigo-->
        <v-snackbar v-model="reset_enviado" color="success" top>
            Se ha enviado un la nueva contraseña
            <template v-slot:action="{ attrs }">
                <v-btn color="success" text v-bind="attrs" @click="reset_enviado = false">Cerrar</v-btn>
            </template>
        </v-snackbar>

        <!-- Dialogo para Mensaje Enviando codigo-->
        <v-dialog v-model="dialog_cargando" max-width="550px"> 
            <v-card>
                <v-card-title class="headline">Sending Code.....</v-card-title>
            </v-card>
        </v-dialog>

        <!-- Dialogo para Mensaje Validando Loginn-->
        <v-dialog v-model="dialog_cargando2" max-width="550px"> 
            <v-card>
                <v-card-title class="headline">Validating .....</v-card-title>
            </v-card>
        </v-dialog>

        <!-- Dialogo para Mensaje cargando-->
        <v-dialog v-model="dialog_guardando" max-width="550px"> 
            <v-card>
                <v-card-title class="headline">Saving.....</v-card-title>
            </v-card>
        </v-dialog>

        <!-- Mensaje de confirmación-->
        <v-snackbar v-model="guardarExitoso" color="success" top>
            Saved successfully
            <template v-slot:action="{ attrs }">
                <v-btn color="success" text v-bind="attrs" @click="registroExitoso = false">Close</v-btn>
            </template>
        </v-snackbar>
    </v-app>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap';
import axios from 'axios';

export default {
    name: "App",
    data() {
        return {
            datos: [],
            agencies: [],
            rols: [],
            correo_corporativo: '',
            pswd: '',
            error: '',
            aprobar: 0,
            user_error: false,   
            dialog_forgot: false,
            dialog_register: false ,
            dialog_ingresar: false,
            codigo_enviado: false, 
            reset_enviado: false,
            codigo_error: false,
            code_login: '',   
            acceso: 0,  
            recover: 0,
            dialog_cargando: false,
            dialog_cargando2: false,
            dato: {
                oid: 0,
                name:'',
                surname: '',
                correo_corporativo: '',
                oid_agency: null,
                oid_rol: 2,
                pswd: '',
            },            
            dialog_guardando: false,
            guardarExitoso: false,
        };
    },
    mounted() {
      this.listar();
    },        
    computed: {
        /*isValidForm() {
            return this.correo_corporativo && this.pswd && this.validar2(this.correo_corporativo) === true && this.validar(this.pswd) === true;
        },*/
        isValidForm() {
            return this.correo_corporativo && this.validar2(this.correo_corporativo) === true;
        },
        isValidForm1() {
            return this.correo_corporativo && this.code_login && this.validar2(this.correo_corporativo) === true;
        },/*
        isValidForm1() {
            return this.correo_corporativo && this.pswd && this.code_login && this.validar2(this.correo_corporativo) === true && this.validar(this.pswd) === true;
        },*/
        isValidForm2() {
            return this.correo_corporativo && this.validar2(this.correo_corporativo) === true;
        },
        isValidForm2_1() {
            return this.correo_corporativo && this.code_login && this.validar2(this.correo_corporativo) === true;
        },
        isValidForm3() {
            return this.dato.correo_corporativo && this.dato.pswd && this.validarCorreo(this.dato.correo_corporativo) === true && this.validar(this.dato.pswd) === true;
        },
    },
    methods: {
        // Obtener la lista de áreas
        async listar() {
            try {
                const response = await axios.get('api/Users/Listar');
                const responseagency = await axios.get('api/Agencies/Listar');
                const responserol = await axios.get('api/Roles/Listar');

                this.datos = response.data;
                this.agencies = responseagency.data;
                this.rols = responserol.data;
            } catch (error) {
                console.error(error);
            }
        },
        async validarYEnviarCodigo() {
            // Realizar una solicitud al servidor para verificar si el correo existe
            const usuarioExistente = this.datos.find(user => user.correo_corporativo === this.correo_corporativo);

            if (usuarioExistente) {
                // Si el usuario existe, enviar código de verificación
                await this.login();
            } else {
                // Si el usuario no existe, registrar el correo
                await this.RegisterNew();
            }
        },
        // Guardar el área creada o actualizada
        async guardar() {
            this.dialog_guardando = true;
            // Validar los campos del formulario antes de guardar
            try {
                // Realizar la lógica para guardar o actualizar el área                    
                await axios.post('api/Users/Register', this.dato);
                
                // Limpiar el formulario después de guardar o actualizar
                this.dato = { oid: 0, name:'', surname: '', correo_corporativo: '', oid_agency: null, oid_rol: 2, pswd: '' };

                // Después de guardar exitosamente el registro:
                this.guardarExitoso = true;
                this.dialog_register = false;
                await this.listar();
                
            } catch (error) {
                console.error(error);
            } finally {
                // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                this.dialog_guardando = false;
            }
        },
        async RegisterNew() {
            // Validar los campos del formulario antes de guardar
            const nuevoUsuario = {
                correo_corporativo: this.correo_corporativo,
                // Otros datos del usuario, si es necesario...
            };
            try {
                // Realizar la lógica para guardar o actualizar el usuario
                await axios.post('api/Users/RegisterNew', nuevoUsuario);
                
                // Limpiar el formulario después de guardar o actualizar
                this.dato = { oid: 0, correo_corporativo: ''};

                // Después de registrar exitosamente el usuario, enviar correo de verificación
                await this.login();
                
            } catch (error) {
                console.error(error);
            } 
        },
        //FUNCIONES PARA INGRESAR
        async login1() {         
            this.dialog_cargando2 = true;
            if (this.$refs.loginForm1.validate()) {
                // Limpiar el mensaje de error
                //this.error = '';
                try {
                    // Realiza la petición HTTP a la API para autenticar al usuario
                    const response = await axios.post('api/Logins/Login1', {
                        correo_corporativo: this.correo_corporativo,
                        //pswd: this.pswd,
                        code_login: this.code_login,
                    });
                    // Verificar si la autenticación fue exitosa (status 200)
                    if (response.status === 200 && response.data.userName!=null) {
                        // Si se recibe un token en la respuesta, el inicio de sesión fue exitoso
                        //const token = response.data.token;
                        const userName = response.data.userName;
                        const oid = response.data.oid;
                        const rol = response.data.rol;

                        // Almacenar el token en local storage o en una cookie para usarlo en futuras solicitudes
                        //localStorage.setItem('token', token);
                        localStorage.setItem('userName', userName);
                        localStorage.setItem('oidu', oid);
                        localStorage.setItem('rolu', rol);
                        this.dialog_ingresar = true;

                        // Redireccionar al usuario a la vista 'AdqInicio' después del inicio de sesión exitoso
                        this.$router.push({ name: 'Inicio' });
                    } 
                    else {
                        // Si la respuesta de la API no tiene un estado de 200, mostrar un mensaje de error al usuario
                        this.error = 'Usuario y/o contraseña y/o código incorrectas. Intente nuevamente.';
                        this.aprobar =1;
                        this.codigo_error = true;
                    }
                
                } catch (error) {
                    // Si hay un error en la respuesta, mostrar un mensaje de error al usuario
                    this.error = 'Usuario y/o contraseña y/o código incorrectas. Intente nuevamente.';
                    this.aprobar =1;
                    this.codigo_error = true;
                } finally {
                    // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                    this.dialog_cargando2 = false;
                }
            }
        },
        async login() {            
            this.dialog_cargando = true;
            if (this.$refs.loginForm.validate()) {
                // Limpiar el mensaje de error
                //this.error = '';
                try {
                    // Realiza la petición HTTP a la API para autenticar al usuario
                    const response = await axios.post('api/Logins/Login', {
                        correo_corporativo: this.correo_corporativo,
                        //pswd: this.pswd,
                    });
                    // Verificar si la autenticación fue exitosa (status 200)
                    if (response.status === 200 && response.data.token!=null) {
                        // Si se recibe un token en la respuesta, el inicio de sesión fue exitoso
                        this.acceso = 1;
                        this.codigo_enviado = true;
                    } 
                    else {
                        // Si la respuesta de la API no tiene un estado de 200, mostrar un mensaje de error al usuario
                        this.error = 'Usuario y/o contraseña incorrectas. Intente nuevamente.';
                        this.aprobar =1;
                        this.user_error = true;
                    }
                
                } catch (error) {
                    // Si hay un error en la respuesta, mostrar un mensaje de error al usuario
                    this.error = 'Usuario y/o contraseña incorrectas. Intente nuevamente.';
                    this.aprobar =1;
                    this.user_error = true;
                } finally {
                    // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                    this.dialog_cargando = false;
                }
            }
        },

        //FUNCIONES PARA RECUPERAR
        async resetPassword() {                      
            this.dialog_cargando = true;
            try {
                // Realiza la petición HTTP a la API para autenticar al usuario
                const response = await axios.post('api/Logins/resetPassword', {
                    correo_corporativo: this.correo_corporativo,
                });
                // Verificar si la autenticación fue exitosa (status 200)
                if (response.status === 200 && response.data.token!=null) {
                    // Si se recibe un token en la respuesta, el inicio de sesión fue exitoso
                    this.recover = 1;
                    this.codigo_enviado = true;
                } 
                else {
                    // Si la respuesta de la API no tiene un estado de 200, mostrar un mensaje de error al usuario
                    this.error = 'Usuario y/o contraseña incorrectas. Intente nuevamente.';
                    this.recover =1;
                    this.user_error = true;
                }
            
            } catch (error) {
                // Si hay un error en la respuesta, mostrar un mensaje de error al usuario
                this.error = 'Usuario y/o contraseña incorrectas. Intente nuevamente.';
                this.recover =1;
                this.user_error = true;
            } finally {
                // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                this.dialog_cargando = false;
            }
        },
        async resetPassword1() {                  
            this.dialog_cargando2 = true;
            try {
                // Realiza la petición HTTP a la API para autenticar al usuario
                const response = await axios.post('api/Logins/resetPassword1', {
                    correo_corporativo: this.correo_corporativo,
                    code_login: this.code_login,
                });
                // Verificar si la autenticación fue exitosa (status 200)
                if (response.status === 200 && response.data.rol!=null) {
                                        
                    this.reset_enviado = true;
                    this.dialog_forgot = false;

                    // Recargar la página
                    window.location.reload();
                } 
                else {
                    // Si la respuesta de la API no tiene un estado de 200, mostrar un mensaje de error al usuario
                    this.error = 'Usuario y/o contraseña y/o código incorrectas. Intente nuevamente.';
                    this.aprobar =1;
                    this.codigo_error = true;
                }
            
            } catch (error) {
                // Si hay un error en la respuesta, mostrar un mensaje de error al usuario
                this.error = 'Usuario y/o contraseña y/o código incorrectas. Intente nuevamente.';
                this.aprobar =1;
                this.codigo_error = true;
            } finally {
                // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                this.dialog_cargando2 = false;
            }
        },
        cerrar() {
            this.dialog_register = false;
        },
        abrir_dialog_forgot() {
            this.dialog_forgot = true;
        },        
        cerrar_dialog_forgot() {
            this.dialog_forgot = false;
        },        
        cerrar_dialog_register() {
            this.dialog_register = false;
        },
        abrir_dialog_register() {
            this.dialog_register = true;
        },
        validar1(value) {
            if (value && value.length > 500) {
                return 'The field cannot exceed 500 characters';
            }
            return true;
        },  
        validar(value) {
            if (value && value.length < 12) {
                return 'The password must contain a minimum of 11 characters';
            }
            // Utiliza expresiones regulares para verificar si se cumplen los requisitos.
            const hasLowercase = /[a-z]/.test(value);//minuscula
            const hasUppercase = /[A-Z]/.test(value);//mayuscula
            const hasNumber = /\d/.test(value);//numero
            const hasSpecialChar = /[!@#$%^&*]/.test(value);//caracter especial

            if (!hasLowercase) {
                return 'The password must contain at least one lowercase letter.';
            }

            if (!hasUppercase) {
                return 'The password must contain at least one uppercase letter.';
            }

            if (!hasNumber) {
                return 'The password must contain at least one number.';
            }

            if (!hasSpecialChar) {
                return 'The password must contain at least one special character (for example: !@#$%^&*).';
            }

            return true;
        }, 
        //VALIDAR COSTO
        validar2(value) {
            const num = /^[A-Za-z0-9._%+-]+@(un|undp|cepal|fao|ilo|iom|paho|unaids|unesco|unfpa|unhcr|unicef|unido|unwomen|wfp|unops)\.org$/;

            if (!num.test(value)) {
                return 'The email must be valid (example@(un|undp|cepal|fao|ilo|iom|paho|unaids|unesco|unfpa|unhcr|unicef|unido|unwomen|wfp|unops).org)';
            }

            if (value.length > 500) {
                return 'The field cannot exceed 500 characters';
            }
/*
            // Realiza una solicitud al servidor para verificar si el correo ya existe y tiene el permiso activo
            const userdata = this.datos.find((user) => user.correo_corporativo === value);

            if (userdata) {
                return 'The user exist';
            }
*/
            return true;
        },

        //VALIDAR CORREO
        validarCorreo(value) {
            const num = /^[A-Za-z0-9._%+-]+@(un|undp|cepal|fao|ilo|iom|paho|unaids|unesco|unfpa|unhcr|unicef|unido|unwomen|wfp|unops)\.org$/;

            if (!num.test(value)) {
                return 'The email must be valid (example@(un|undp|cepal|fao|ilo|iom|paho|unaids|unesco|unfpa|unhcr|unicef|unido|unwomen|wfp|unops).org)';
            }

            if (value.length > 500) {
                return 'The field cannot exceed 500 characters';
            }
            // Realiza una solicitud al servidor para verificar si el correo ya existe
            const userdata = this.datos.find((user) => user.correo_corporativo === value);

            if (userdata) {
                return 'The email already exists, please enter another';
            }

            return true;
        },
    },
}
</script>
<style>
    .divider:after,
    .divider:before {
        content: "";
        flex: 1;
        height: 1px;
        background: #eee;
    }
    @media (max-width: 450px) {
        .h-custom {
            height: 100%;
        }
    }
    .btncolor{
        color:"blue"
    }
    .theme--light.v-btn.v-btn--has-bg {
        background-color: rgb(15, 135, 201);
    }
    .error-message {
        color: red;
    }
</style>